import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import { SFT_Targets } from "../models/SFT_Targets";
import Modal from "react-bootstrap/Modal";
import { DM_PT_DataSheet } from "../models/DM_PT_DataSheet";
import { ProtectiveFunction } from "../models/ProtectiveFunction";



interface Props {
    closeModal: () => void;
    sftTargets: SFT_Targets;
    protectiveFunction: ProtectiveFunction;
    handleTargetSpecUpdate: (target_pfd: number, target_mttf: number) => void;

}
interface State {
    closeFocus: boolean;
}

export class TargetSpecModal extends React.Component<Props, State> {
  constructor(props: Props) {
      super(props);
      this.state = { closeFocus: false }
    }

    private targetPfdInput = React.createRef<HTMLInputElement>();
    private targetMttf = React.createRef<HTMLInputElement>();


    handleClick = (e: React.MouseEvent) => {
        const newPfd = parseFloat(this.targetPfdInput.current.value);
        if (isNaN(newPfd)) {
            // TODO: alert the user
            return;
        }
        const newMttf = parseFloat(this.targetMttf.current.value);
        if (isNaN(newMttf)) {
            // TODO: alert the user
            return;
        }
        console.log(newPfd, newMttf);

        this.props.handleTargetSpecUpdate(newPfd, newMttf);
        this.props.closeModal();
    }

    onMouseEnter = () => {
        this.setState({
            closeFocus: true
        })
    }

    onMouseLeave = () => {
        this.setState({
            closeFocus: false
        })
    }

    

  render() {
    
      const closeModal = this.props.closeModal;
      var closeClass = this.state.closeFocus ? "ui-dialog-titlebar-close ui-corner-all ui-state-hover" : "ui-dialog-titlebar-close ui-corner-all";


    return (

      <Modal
        show={true}
        animation={false}
        centered={true}
        onEscapeKeyDown={() => closeModal()}
        onHide={() => { /* don't allow hide via off-click*/ }}
        size="lg"
        enforceFocus={true}
            style={{ zIndex: 10001, background: "rgba(000, 000, 000, 0.5)" }}
      >
            <div className="ui-dialog ui-widget ui-widget-content ui-corner-all ui-draggable" tabIndex={-1} role="dialog" aria-labelledby="ui-dialog-title-target_popup" style={{ display: 'block', zIndex: 1002, outline: '0px', height: 'auto', width: '350px', top: '400px', left: '350px' }}>
                <div className="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix">
                    <span className="ui-dialog-title" id="ui-dialog-title-target_popup">Target Specification</span>
                    <div className={closeClass} role="button">
                        <span className="ui-icon ui-icon-closethick" style={{ cursor: "pointer" }} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={() => closeModal()}>close</span>
                    </div>
                </div>
                <div id="target_popup" className="ui-dialog-content ui-widget-content" style={{ display: 'block', width: 'auto', minHeight: '0px', height: '162.522px' }}>
              <div style={{ paddingLeft: '20px', paddingTop: '20px' }}>
                <table>
                  <tbody><tr>
                    <td className="custom_device">
                      <span id="Label99">PFDavg</span>
                    </td>
                    <td className="custom_device_text">
                        <input name="target_pfd" defaultValue={(this.props.sftTargets != null && this.props.sftTargets.xpfDavg != null) ? this.props.sftTargets.xpfDavg : ""} type="text" id="target_pfd" ref={this.targetPfdInput} />
                    </td>
                  </tr>
                    <tr>
                      <td className="custom_device">
                        <span id="Label132">MTTFs (Yr)</span>
                      </td>
                      <td className="custom_device_text">
                        <input name="target_mttf" defaultValue={(this.props.sftTargets != null && this.props.sftTargets.xmttf != null) ? this.props.sftTargets.xmttf : ""} type="text" id="target_mttf" ref={this.targetMttf} />
                      </td>
                    </tr>
                  </tbody></table>
              </div>
              <div style={{ paddingTop: '20px' }}>
                <input type="submit" name="Target_save" value="Update" id="Target_save" onClick={(e: React.MouseEvent)=>this.handleClick(e)}/>
              </div>
                </div>
            </div>
      </Modal>
    );
  }
}